(() => {
  const q = (s, root = document) => root.querySelector(s);
  const qa = (s, root = document) => [...root.querySelectorAll(s)];

  function heroSlider() {
    return;
    qa('[data-tw-hero-slider]').forEach((hero) => {
      if (hero.dataset.clientSlider) return;
      hero.dataset.clientSlider = 'true';
      qa('.tw-hero__media', hero).forEach((media) => {
        const mobile = media.classList.contains('tw-hero__media--mobile');
        const source = mobile ? hero.dataset.twMobileVideo : hero.dataset.twDesktopVideo;
        const primary = q('img,video,svg', media);
        if (!source || !primary) return;
        primary.classList.add('tw-hero__slide', 'is-active');
        const video = document.createElement('video');
        video.className = 'tw-hero__video tw-hero__slide';
        Object.assign(video, { src: source, muted: true, loop: true, playsInline: true, preload: 'metadata' });
        media.appendChild(video);
      });
      if (!qa('.tw-hero__slide', hero).length) return;
      let current = 0;
      const show = (index) => {
        current = (index + 2) % 2;
        qa('.tw-hero__media', hero).forEach((media) => qa('.tw-hero__slide', media).forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          if (slide.tagName === 'VIDEO') i === current ? slide.play().catch(() => {}) : slide.pause();
        }));
        qa('[data-tw-hero-dot]', hero).forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
      };
      const controls = document.createElement('div');
      controls.className = 'tw-hero__slider-controls';
      controls.innerHTML = '<button type="button" data-prev aria-label="Previous slide">&#8249;</button><button type="button" data-tw-hero-dot aria-label="Show image" aria-current="true"></button><button type="button" data-tw-hero-dot aria-label="Show video"></button><button type="button" data-next aria-label="Next slide">&#8250;</button>';
      hero.appendChild(controls);
      q('[data-prev]', controls).onclick = () => show(current - 1);
      q('[data-next]', controls).onclick = () => show(current + 1);
      qa('[data-tw-hero-dot]', controls).forEach((dot, i) => dot.onclick = () => show(i));
      window.setInterval(() => show(current + 1), 6500);
    });
  }

  function homepage() {
    if (!document.body.classList.contains('template-index')) return;
    const best = q('[id$="__featured_new_collection_ryWzxD"]');
    const collections = q('[id$="__new_collection_list_UTRNEq"]');
    if (best && collections) collections.parentNode.insertBefore(best, collections);
    qa('.tw-hero a').forEach((link) => {
      const text = link.textContent.trim().toLowerCase();
      if (text.includes('explore best seller')) link.href = '/collections/best-seller';
      if (text.includes('shop by collection') && link.closest('.tw-hero')) link.href = '#shop-by-collection';
    });
    const heroStars = q('.tw-hero__stars');
    if (heroStars) heroStars.style.setProperty('color', '#CEAC66', 'important');
  }

  function arrows() {
    qa('.tw-mobile-slider .tw-collection-tiles__grid, .tw-cro-collection-tabs').forEach((track) => {
      if (track.dataset.clientArrows) return;
      track.dataset.clientArrows = 'true';
      const wrapper = track.parentElement;
      if (!wrapper) return;
      const buttons = [];
      ['prev','next'].forEach((direction) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = `tw-scroll-arrow tw-scroll-arrow--${direction}`;
        button.innerHTML = direction === 'next' ? '&#8250;' : '&#8249;';
        button.setAttribute('aria-label', `${direction === 'next' ? 'Next' : 'Previous'} collections`);
        button.onclick = () => track.scrollBy({ left: (direction === 'next' ? 1 : -1) * Math.max(240, track.clientWidth * .75), behavior: 'smooth' });
        wrapper.appendChild(button);
        buttons.push(button);
      });
      const refresh = () => {
        const enabled = track.scrollWidth > track.clientWidth + 4;
        wrapper.classList.toggle('tw-scroll-with-arrows', enabled);
        buttons.forEach((button) => { button.hidden = !enabled; });
      };
      refresh();
      window.addEventListener('resize', refresh, { passive: true });
    });
  }

  function ensureShopAll() {
    qa('.tw-standard-header-menu__list').forEach((list) => {
      const exists = qa(':scope > li > a', list).some((link) => link.textContent.trim().toLowerCase() === 'shop all');
      if (!exists) list.insertAdjacentHTML('afterbegin', '<li class="tw-standard-header-menu__item"><a href="/collections/all" class="menu-list__link"><span class="menu-list__link-title">Shop All</span></a></li>');
    });

    qa('.menu-drawer__menu.has-submenu').forEach((list) => {
      const exists = qa(':scope > li > a, :scope > li > details > summary', list).some((link) => link.textContent.trim().toLowerCase() === 'shop all');
      if (!exists) list.insertAdjacentHTML('afterbegin', '<li class="menu-drawer__list-item--flat"><a href="/collections/all" class="menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset"><span class="menu-drawer__menu-item-text wrap-text">Shop All</span></a></li>');
    });
  }

  function product() {
    if (!document.body.classList.contains('template-product')) return;
    const details = q('.product-details');
    if (details && !q('.tw-product-meta', details)) {
      const logo = q('#header-group img, header img');
      const date = new Date(); let days = 0;
      while (days < 12) { date.setDate(date.getDate() + 1); if (![0,6].includes(date.getDay())) days++; }
      const meta = document.createElement('div');
      meta.className = 'tw-product-meta';
      const soldOut = Boolean(q('button[name="add"][disabled], [data-add-to-cart][disabled]', details));
      const stockText = soldOut ? 'Currently unavailable' : 'Available to order';
      meta.innerHTML = `<div class="tw-product-meta__info"><span class="tw-product-meta__stock"><i aria-hidden="true"></i>${stockText}</span><span class="tw-product-meta__delivery">Estimated delivery by ${date.toLocaleDateString('en-US',{month:'short',day:'numeric'})}</span></div>${logo ? `<img src="${logo.currentSrc || logo.src}" alt="Woof Wow">` : '<strong class="tw-product-meta__brand">Woof Wow</strong>'}`;
      details.prepend(meta);
    }
    /* Product-specific rating is already displayed beside the title. Remove
       the old repeated store-wide review claim from previously rendered DOM. */
    qa('.tw-product-meta__trust', details || document).forEach((trust) => trust.remove());
    qa('[role="tabpanel"]').forEach((panel) => {
      if (/support|help|question/i.test(panel.textContent || '') && !q('a[href^="mailto:"]', panel)) panel.insertAdjacentHTML('beforeend','<p><strong>Need help?</strong> Email <a href="mailto:roldanedgy@gmail.com">roldanedgy@gmail.com</a>.</p><p><strong>30-day product issue support.</strong> Contact us if an item arrives damaged, defective or incorrect.</p>');
    });
    qa('button,label,span,p').forEach((node) => { if (!node.children.length && /buy 2/i.test(node.textContent || '') && /5%/.test(node.textContent)) node.textContent = node.textContent.replace(/5%/g,'10%'); });
    if (/vibration[- ]plate/i.test(location.pathname)) window.setTimeout(() => { const thumbs = qa('button[id*="thumbnail"],.slideshow-control__thumbnail'); if (thumbs[1]) thumbs[1].click(); }, 600);
  }

  function shopByCollectionScroll() {
    if (document.documentElement.dataset.twCollectionScrollBound === 'true') return;
    document.documentElement.dataset.twCollectionScrollBound = 'true';

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-shop-by-collection-trigger], a[href="#shop-by-collection"]');
      if (!link) return;

      const target = document.getElementById('shop-by-collection');
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#shop-by-collection');
      }
    }, true);
  }

  function globalFixes() {
    qa('a').forEach((link) => {
      const text = link.textContent.trim().toLowerCase();
      const href = link.getAttribute('href') || '';
      if (text === 'shop all') link.href = '/collections/all';
      if (text === 'shop by collection' && href.includes('TwCollectionTiles')) link.href = '#shop-by-collection';

      const label = link.querySelector('.menu-list__link-title,.menu-drawer__menu-item-text');
      if (!label) return;
      if (href.includes('/collections/skin-body-care')) label.textContent = 'Skin & Body Care';
      if (href.includes('/collections/menstrual-care')) label.textContent = 'Menstrual Care';
      if (href.includes('/collections/comfort-items')) label.textContent = 'Comfort Items';
    });
  }

  function init() { shopByCollectionScroll(); heroSlider(); homepage(); arrows(); ensureShopAll(); product(); globalFixes(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
